import RequestBase from './RequestBase';

export default class GetDocumentRequest extends RequestBase {
    constructor(documentTypeId, documentId) {
        super();
        this._url = '/Documents/{documentTypeId}/{documentId}';
        this.method = 'GET';
        this.documentTypeId = documentTypeId;
        this.documentId = documentId;
    }
}



// WEBPACK FOOTER //
// ./src/Resources/Documents.js